export const audioData = {
	'quantum': {
		name: "quantum",
		url: "./quantum.mp3",
	},
	'error': {
		name: "error",
		url: "./error.mp3",
	},
	'buttonup': {
		name: "buttonup",
		url: "./buttonup.mp3",
	},
	'buttondown': {
		name: "buttondown",
		url: "./buttondown.mp3",
	},
	'click':{
		name: "click",
		url: "./click.mp3",
	},
	'bzzz': {
		name: "bzzz",
		url: "./bzzz.mp3",
	},
	'buttonclick': {
		name: "buttonclick",
		url: "./beep.mp3",
	},
	'newemail': {
		name: "newemail",
		url: "./1new.mp3",
	},
	'newemails': {
		name: "newemail",
		url: "./4new.mp3",
	},
	'ending': {
		name: "ending",
		url: "./ending.mp3",
	}

}